/* La Femme restock page: shared behaviour for the lfr-* sections. Built by This Is Growth. */
(function () {
  if (window.lfrRestock) return;
  window.lfrRestock = true;

  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    return { add: r.cart_add_url || '/cart/add.js', cart: r.cart_url || '/cart' };
  }

  function bindGallery(gallery) {
    if (gallery.dataset.lfrBound) return;
    gallery.dataset.lfrBound = '1';
    var main = gallery.querySelector('[data-lfr-main-img]');
    gallery.querySelectorAll('.lfr-thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = b.dataset.src;
        main.alt = b.dataset.alt;
        gallery.querySelectorAll('.lfr-thumbs button').forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
      });
    });
  }

  function announce(form, variantId, sections) {
    return import('@theme/events').then(function (m) {
      form.dispatchEvent(new m.CartAddEvent({}, variantId, { source: 'lfr-restock', itemCount: 1, variantId: variantId, sections: sections }));
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else location.href = routes().cart;
    });
  }

  // Same flow as the theme's product form: add in the background, announce a cart update so the
  // header count and drawer refresh, then open the drawer. Any failure falls back to a normal submit.
  function bindForm(form) {
    if (form.dataset.lfrBound) return;
    form.dataset.lfrBound = '1';
    var btn = form.querySelector('[data-lfr-add]');
    var err = form.querySelector('[data-lfr-error]');
    if (!btn) return;
    var label = btn.textContent;
    var msg = form.dataset.lfrMsg || 'Choose your size.';
    function chosen() { return form.querySelector('input[name="id"]:checked'); }
    function reset() { btn.removeAttribute('aria-busy'); btn.textContent = label; }
    form.lfrChosen = chosen;
    form.lfrMsg = msg;
    form.addEventListener('change', function () {
      var c = chosen();
      if (!c) return;
      err.textContent = '';
      var size = document.querySelector('[data-lfr-sticky-size]');
      if (size && form.hasAttribute('data-lfr-form')) size.textContent = 'Size ' + c.dataset.title;
    });
    form.addEventListener('submit', function (e) {
      if (!chosen()) {
        e.preventDefault();
        err.textContent = msg;
        var first = form.querySelector('input[name="id"]:not(:disabled)');
        if (first) first.focus();
        return;
      }
      if (btn.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding…';
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var data = new FormData(form);
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
      if (ids.length) data.append('sections', ids.join(','));
      fetch(routes().add, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            err.textContent = res.description || res.message || 'That size could not be added. Please try again.';
            reset();
            return;
          }
          btn.textContent = 'Added';
          setTimeout(reset, 2000);
          announce(form, String(data.get('id')), res.sections).catch(function () { location.href = routes().cart; });
        })
        .catch(function () { form.submit(); });
    });
    window.addEventListener('pageshow', reset);
  }

  // Phones: an Add to bag bar once the main button scrolls away, hidden while the About section or the
  // footer is on screen so it never covers their links. Works wherever the sections are placed.
  function bindSticky() {
    var sticky = document.querySelector('[data-lfr-sticky]');
    var form = document.querySelector('form[data-lfr-form]');
    if (!sticky || !form || sticky.dataset.lfrBound) return;
    sticky.dataset.lfrBound = '1';
    var btn = form.querySelector('[data-lfr-add]');
    var stickyBtn = sticky.querySelector('[data-lfr-sticky-btn]');
    if (!btn || !stickyBtn) return;
    stickyBtn.addEventListener('click', function () {
      if (form.lfrChosen && form.lfrChosen()) { form.requestSubmit ? form.requestSubmit(btn) : form.submit(); return; }
      form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      var err = form.querySelector('[data-lfr-error]');
      if (err) err.textContent = form.lfrMsg || '';
    });
    if (!('IntersectionObserver' in window)) return;
    var ends = [document.querySelector('[data-lfr-about]'), document.querySelector('footer')].filter(Boolean);
    var btnVisible = true, endsVisible = {};
    function update() {
      var anyEnd = Object.keys(endsVisible).some(function (k) { return endsVisible[k]; });
      var show = !btnVisible && !anyEnd;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (en) { btnVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; update(); }).observe(btn);
    ends.forEach(function (el, i) {
      new IntersectionObserver(function (en) { endsVisible[i] = en[0].isIntersecting; update(); }).observe(el);
    });
  }

  function init() {
    document.querySelectorAll('[data-lfr-gallery]').forEach(bindGallery);
    document.querySelectorAll('form[data-lfr-cart-form]').forEach(bindForm);
    bindSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor: sections re-render when settings change or sections move.
  document.addEventListener('shopify:section:load', init);
})();